module.exports = __webpack_public_path__ + "img/icon4.974b189f.png";